class Hashrate {
    constructor(id, pow10, unitName) {
        this.id = id;
        this.one = Math.pow(10, pow10);
        this.unitName = unitName;
    }
    format(value) {
        return this.formatToFixed(value, 2);
    }
    formatToHashrateString(value) {
        return (value / this.one).toLocaleString() + " " + this.unitName;
    }
    formatToHashrateStatsBoxString(value) {
        return (value / this.one).toFixed(3).toLocaleString() + " " + this.unitName;
    }
    toString() {
        return this.id;
    }
}

export const HASHRATE = {
    SOLS: new Hashrate("SOLS", 0, "Sol/s"),
    KSOLS: new Hashrate("KSOLS", 3, "KSol/s"),
    MSOLS: new Hashrate("MSOLS", 6, "MSol/s"),
    GSOLS: new Hashrate("GSOLS", 9, "GSol/s"),
    TSOLS: new Hashrate("TSOLS", 12, "TSol/s"),
};

const HASHRATES = [HASHRATE.SOLS, HASHRATE.KSOLS, HASHRATE.MSOLS, HASHRATE.GSOLS, HASHRATE.TSOLS];

/**
 * Formats a raw hashrate value (in Sol/s) to the next largest unit with 3 decimal places.
 * Examples:
 *   435324 → "435.324 KSol/s"
 *   225332185 → "225.332 MSol/s"
 *   1234567890123 → "1.234 TSol/s"
 *
 * @param {number} rawValue - The raw hashrate value in Sol/s (base unit)
 * @returns {string} Formatted hashrate string with appropriate unit
 */
export const formatHashrateToUnit = rawValue => {
    if (rawValue === 0 || rawValue === null || rawValue === undefined) {
        return "0.000 Sol/s";
    }

    const absValue = Math.abs(rawValue);

    // Find the appropriate unit (largest unit where value >= 1)
    let selectedUnit = HASHRATE.SOLS;
    for (let i = HASHRATES.length - 1; i >= 0; i--) {
        if (absValue >= HASHRATES[i].one) {
            selectedUnit = HASHRATES[i];
            break;
        }
    }

    const convertedValue = rawValue / selectedUnit.one;
    return convertedValue.toFixed(3) + " " + selectedUnit.unitName;
};

export const getHashrateUnit = (value, startUnit) => {
    var referenceHashrate = HASHRATES[0];
    for (var i = HASHRATES.length - 1; i >= 0; i--) {
        var hashrate = HASHRATES[i];
        if (value * startUnit.one >= hashrate.one) {
            referenceHashrate = hashrate;
            break;
        }
    }
    return referenceHashrate;
};

export const formatAsPercentageOfTotal = (value, total) => {
    if (total !== 0) {
        return ((value * 100) / total).toFixed(3) + " %";
    }
    return "0.000 %";
};

export const calculatePercentage = (value, total) => {
    if (total !== 0) {
        return (value * 100) / total;
    }
    return 0;
};

export const convertTo = (value, startUnit, endUnit) => {
    return ((value * startUnit.one) / endUnit.one).toFixed(3);
};

export default getHashrateUnit;
